import CacheInstallationState from './interfaces/CacheInstallationState';
import { MappedServiceWorkerOpticsKeys } from './interfaces/ServiceWorkerOpticsKeys';
import { logUsage } from 'owa-analytics';

const DATAPOINT_NAME = 'SWCache';

export default function logServiceWorkerOptics(
    state: CacheInstallationState,
    eventName: string,
    cacheVersion?: string,
    error?: string,
    resource?: string,
    status?: number,
    stack?: string
) {
    let optics: MappedServiceWorkerOpticsKeys = {};
    optics.ev = eventName;
    optics.cv = cacheVersion;
    optics.e = error;
    optics.rc = state.resourcesCached;
    optics.ccs = state.cacheCleanupStatus;
    optics.ncc = state.numberOfCachesCleaned;
    optics.r = resource;
    optics.st = status;
    optics.stk = stack;
    optics.ch = state.cacheHealth;
    optics.app = state.appName;

    // reset per install tracking events
    state.resourcesCached = 0;
    state.cacheCleanupStatus = 0;
    state.numberOfCachesCleaned = 0;

    logUsage(DATAPOINT_NAME, <any>optics);
}
